import { useStore } from 'vuex'

export function i18nKey(initialKey) {
    return useStore().getters.customTranslations[initialKey] || initialKey
}
